@if (replyTo()) {
  <div class="reply-preview-strip">
    <div class="reply-preview-text">
      <span class="reply-label">Replying to</span>
      <span class="reply-quoted">{{ replyTo()!.text }}</span>
    </div>
    <button
      type="button"
      class="cancel-reply-btn"
      (click)="cancelReply.emit()"
      aria-label="Cancel reply"
    >
      ×
    </button>
  </div>
}

<!-- ── Emoji Picker ──────────────────────────────────────────────────────── -->
@if (emojiPickerOpen()) {
  <div class="emoji-picker" (click)="$event.stopPropagation()">
    <div class="emoji-categories">
      @for (cat of emojiCategories; track cat.label; let i = $index) {
        <button
          type="button"
          class="emoji-cat-btn"
          [class.active]="activeCategoryIndex() === i"
          (click)="selectCategory(i)"
          [attr.aria-label]="cat.label"
        >
          {{ cat.icon }}
        </button>
      }
    </div>
    <div class="emoji-grid">
      @for (
        emoji of emojiCategories[activeCategoryIndex()].emojis;
        track emoji
      ) {
        <button type="button" class="emoji-btn" (click)="insertEmoji(emoji)">
          {{ emoji }}
        </button>
      }
    </div>
  </div>
}

<!-- ── Pending image preview ──────────────────────────────────────────────── -->
@if (pendingImage()) {
  <div class="pending-image-strip" (click)="$event.stopPropagation()">
    <img [src]="pendingImage()!" class="pending-thumb" alt="Selected image" />
    <div class="pending-image-info">
      <span class="view-once-badge">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        View once
      </span>
    </div>
    <button
      type="button"
      class="remove-image-btn"
      (click)="clearPendingImage()"
      aria-label="Remove image"
    >
      ×
    </button>
  </div>
}

<input
  #imageInput
  type="file"
  accept="image/jpeg,image/png,image/gif,image/webp,image/heic,image/heif"
  style="display: none"
  (change)="onImageSelected($event)"
/>

<div class="composer" (click)="closeEmojiPicker()">
  <button
    type="button"
    (click)="skip.emit()"
    class="skip-button"
    aria-label="Skip to next match"
  >
    Next
  </button>
  <div class="chat-input-wrapper">
    <button
      type="button"
      class="gallery-toggle"
      (click)="openImagePicker($event)"
      aria-label="Send a photo"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="8.5" cy="8.5" r="1.5" />
        <path d="M21 15l-5-5L5 21" />
      </svg>
    </button>
    <button
      type="button"
      class="emoji-toggle"
      (click)="toggleEmojiPicker($event)"
      aria-label="Open emoji picker"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
        <line x1="9" y1="9" x2="9.01" y2="9" />
        <line x1="15" y1="9" x2="15.01" y2="9" />
      </svg>
    </button>
    <textarea
      #messageInput
      placeholder="Type a message…"
      autocomplete="off"
      autocapitalize="sentences"
      autocorrect="on"
      spellcheck="false"
      data-form-type="chat"
      data-lpignore="true"
      name="chat-message"
      inputmode="text"
      rows="1"
      class="chat-input"
      [ngModel]="draft()"
      (ngModelChange)="draft.set($event); onTypingInput($event)"
      (keyup.enter)="onSend()"
    ></textarea>
  </div>
  <button
    type="button"
    class="send-button"
    aria-label="Send message"
    [disabled]="!hasSendable()"
    (click)="onSend()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="m22 2-7 20-4-9-9-4Z"></path>
      <path d="M22 2 11 13"></path>
    </svg>
  </button>
</div>
